import React from 'react';
import AdminElectricalStylePricingEditor from './AdminElectricalStylePricingEditor';

const SERVICES = {
  400: { name: 'Lock Changes' },
  401: { name: 'Locksmith Services' },
};

const AdminLocksSecurityPricingRules = ({ isTabMode = false }) => (
  <AdminElectricalStylePricingEditor
    services={SERVICES}
    title="Locks & Security Pricing Rules"
    description="Manage pricing for 2 locks and security services"
  />
);

export default AdminLocksSecurityPricingRules;
